module.exports = __webpack_public_path__ + "static/media/view5.fd5246bb.jpg";